import React, { useState } from "react";
//Components
import Loading from "../../../components/Loading/Loading";
import { FaEye } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../../../redux/slice/authSlice";
// import { setModalContent, setShowModal } from "../../../redux/slice/modalSlice";
import toast from "react-hot-toast";
import { filterMembreships, sendData } from "./sendData";
import { getUserById } from "../../../services/rest/users/userService";
import { getAllMemberships } from "../../../services/rest/membership/membershipService";
import { useDispatch } from "react-redux";
import { setUserData } from "../../../redux/slice/userSlice";
import { initialState as reduxInitialStateUser } from "../../../redux/slice/userSlice";
import { setMembership } from "../../../redux/slice/membershipSlice";
import { handleError } from "../../../utils/handleError";

const FormSigIn = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const initialFormValues = {
    email: "",
    password: "",
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const nowDate = new Date();
  const auxDate = nowDate.toISOString();
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const { userData, refreshToken } = await sendData({
        formValues,
        setErrors,
      });
      if (!userData) {
        setLoading(false);
        toast.error("Verifica tus datos");
        return;
      }
      dispatch(login({ token: refreshToken, isAuthenticated: false }));
      const responseUserData = await getUserById(userData?.id);
      const responseMembership = await getAllMemberships();
      const { userMembership } = filterMembreships(
        responseMembership,
        responseUserData?.membership
      );
      dispatch(
        setMembership({
          _id: userMembership?._id ?? 0,
          planName: userMembership?.planName ?? "Free",
          price: userMembership?.price ?? 0,
          currency: userMembership?.currency ?? "MXN",
          description: userMembership?.description ?? [],
          routeLimit: userMembership?.routeLimit ?? 0,
          membershipStatus: responseUserData?.membershipStatus ?? "inactive",
          lastPayment: responseUserData?.paymentDate ?? auxDate,
          nextPayment: responseUserData?.expiresDateMembership ?? auxDate,
        })
      );
      dispatch(setUserData({ ...reduxInitialStateUser, ...responseUserData }));
      dispatch(login({ token: refreshToken, isAuthenticated: true }));
      setErrors({});
      setFormValues(initialFormValues);
      navigate("/dashboard/history");
      toast.success(
        `Bienvenido a Radaria ${responseUserData?.firstName ?? ""}`,
        { duration: 10000 }
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const { message } = handleError(error);
      toast.error(`Algo salio mal. \n ${message}`, { duration: 10000 });
    }
  };

  return (
    <>
      <Loading loading={loading} />
      <form
        action=""
        onSubmit={(e) => handleSubmit(e)}
        className="d-flex flex-column"
      >
        <div className="mb-3 " style={{ width: "85%" }}>
          <label htmlFor="inputEmailLogin" className="form-label">
            Correo electrónico{" "}
          </label>
          <input
            type="email"
            name="email"
            value={formValues.email}
            onChange={handleChange}
            className={`form-control ${
              errors.email && "is-invalid input-error"
            } text-light`}
            id="inputEmai"
            placeholder="correo@ejemplo.com"
          />
          {errors.email && (
            <div id="validationServer05Feedback" className="invalid-feedback">
              {errors.email}
            </div>
          )}
        </div>
        <div className="mb-3 mt-3 " style={{ width: "85%" }}>
          <label htmlFor="inputPasswordLogin" className="form-label">
            Contraseña
          </label>
          <div className="input-group">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formValues.password}
              onChange={handleChange}
              className={`form-control ${
                errors.password && "is-invalid input-error"
              } text-light`}
              id="inputPasswordLogin"
              placeholder="Ingrese su contraseña"
              aria-label="Recipient's username"
              aria-describedby="button-addon2"
            />
            <button
              className="btn btn-outline-primary"
              type="button"
              id="button-addon2"
              onClick={() => setShowPassword(!showPassword)}
            >
              <FaEye />
            </button>
          </div>
          {errors.password && (
            <div id="validationServer05Feedback" className="invalid-feedback">
              {errors.password}
            </div>
          )}
        </div>
        <div className="col-auto mt-4">
          <button type="submit" className="btn btn-primary ">
            Ingresar
          </button>
        </div>
        <div className="mt-3">
          <Link to="/reset-password">¿Olvidaste tu contraseña?</Link>
        </div>
        <div className="mt-2">
          <Link to="/auth/specialist">¿Tienes cuenta de especialista?</Link>
        </div>
      </form>
    </>
  );
};
export default FormSigIn;
